<template>
   <div class="content-wrapper" style="background: rgb(237, 240, 242);">
      <section class="content-header">
         <div class="row">
            <div class="col-xs-5">
               <h1>
                  Dashboard
               </h1>
            </div>
            <div class="col-xs-7 mandatoryDiv">
               <span class="letter-right"> Last Refresh Time: {{refresh_datetime}}</span>
               <a class="btn btn-sm btn-add" @click="refreshDashboard"><i class="fa fa-refresh"></i> Refresh</a>
            </div>
         </div>
      </section>
      <section class="content">
         <div class="row">
            <!-- /.col -->
            <div class="col-md-6 col-sm-12 col-xs-12">
               <div class="info-box">
                  <span class="info-box-icon bg-yellow"><i class="ion ion-ios-people-outline"></i></span>
                  <div class="info-box-content">
                     <span class="">
                     Total Subscribed (VPN)
                     </span>
                     <router-link :to="{path: 'pinsubscriptionreport'}"><span class="info-box-number" id="totSubscribedPin">
                        <img v-if="loading_data" src="/assets/img/loading_h.gif" alt="Loading"/>
                        <span>{{totSubscribedPin}}</span>
                     </span> </router-link>

                     <div v-if="showOnlinePinData">
                        <hr style="margin: 0; padding: 0;">
                        <a href="" title="Online PIN"> 
                           <span> <i class="fa fa-desktop text-success"></i>  </span> 
                           <img v-if="loading_data" src="/assets/img/loading_h.gif" alt="Loading"/>
                           <span id="totalOnlineSubscribedPin"> {{totalOnlineSubscribedPin}} </span>
                        </a>
                     </div>

                  </div>
                  <!-- /.info-box-content -->
               </div>
               <!-- /.info-box -->
            </div>
            <!-- /.col -->
            <div class="col-md-6 col-sm-12 col-xs-12">
               <div class="info-box">
                  <span class="info-box-icon bg-aqua"><i class="fa  fa-user-plus"></i></span>
                  <div class="info-box-content">
                     <span class=""> Today Subscribed (VPN)</span>
                     <router-link :to="{path: 'pinsubscriptionreport'}">
                        <span class="info-box-number" id="todSubscribedPin">
                           <img v-if="loading_data" src="/assets/img/loading_h.gif" alt="Loading"/>
                           <span>{{todSubscribedPin}}</span>
                        </span> 
                     </router-link>

                     <div v-if="showOnlinePinData">
                        <hr style="margin: 0; padding: 0;">
                        <a href="" title="Online PIN"> 
                           <span> <i class="fa fa-desktop text-success"></i>  </span> 
                           <img v-if="loading_data" src="/assets/img/loading_h.gif" alt="Loading"/>
                           <span id="todayOnlineSubscribedPin"> {{todayOnlineSubscribedPin}} </span>
                        </a>
                     </div>
                  </div>
                  <!-- /.info-box-content -->
               </div>
               <!-- /.info-box -->
            </div>
         </div>

         <!--Subscription Graph Start-->
         <SubscribePinsGraph v-if="renderComponent" />
         <!--Subscription Graph End-->

         <!--Hourly Pin subscription report for last 7 day-->  
         <HourlyPinSection v-if="renderComponent" />
         <!--End Hourly Pin subscription report for last 7 day-->
         <!--Secton two end-->
      </section>
   </div>
</template>
<script>
   import axios from 'axios'
   import HourlyPinSection from "@/components/dashboardComponents/HourlyPinSection.vue";
   import SubscribePinsGraph from "@/components/dashboardComponents/SubscribePinsGraph.vue";
   export default {
      name: "DashboardSubscriptionsBaseSales",
      components: {
         HourlyPinSection,
         SubscribePinsGraph,
      },
      data() {
         return {
            renderComponent : true,
            refresh_datetime : '',
            loading_data : true,
            ts_rp : '',
            ts_wp : '',
            ts_sum : '',
            opc_today : '',
            opc_yes : '',
            yestotal : '',
            rpc_today : '',
            rpc_yes : '',
            rpc_sum : '',
            life_time_total_pins : '',
            totSubscribedPin : '',
            todSubscribedPin : '',
            life_time_total_pins_price : '',
            totRecharge : '',
            todRecharge : '',

            totalOnlineSubscribedPin : '',
            todayOnlineSubscribedPin : '',
            showOnlinePinData : false,

            self_indicator : '',
            reseller_indicator : '',

            tbl1_loading_data : true,

            reseller_list : {},
            paymentArr : [],
            rechargeArr : [],
            topResellerArr : [],
            adBannerUrl : '',
            imgWidth : '80%',
            imgHeight : '350px',
            adBannerRedirectLink : '',
         }
      },
      props: {
         msg: String,
      },
      created(){
         this.com_user_type_access([0,1], true);
         this.loadDashboardData();
         this.loadPaymentData();
         this.loadRechargeData();
         this.loadTopResellerData();
         this.showOnlinePinData = this.com_onlineReportAccess();
      },
      methods: {
         imagePopup(){
            var rootObj = this;
            const img = new Image();
            img.onload = function() {
               rootObj.imgWidth = this.width+'px';
               rootObj.imgHeight = this.height+'px';
                //alert(this.width + 'x' + this.height);
                //alert(rootObj.imgWidth + 'x' + rootObj.imgHeight);
            }
            img.src = this.$store.getters.getPanelData.reseller_panel_home_img;

            $('.imagePopup').colorbox({opacity: 0.9,  'background-color': 'red', height: rootObj.imgHeight, width: rootObj.imgWidth, 'inline':true, 'open':true, href:function(){
                  return "#banner";
               }});
         },
         loadDashboardData(){
            var rootObj = this;
            loader.show();
            this.refresh_datetime = this.com_currentDateTime('dmy');

            const form = new FormData()
            var config = {
             headers: { 'Content-Type': 'multipart/form-data' }
            }
            axios.post('dashboard/load-dashboard-pin-count-data', form, config).then(function (response) {
               var dashboardData = response.data.data;
               //console.log(dashboardData);

               rootObj.loading_data = false;
               rootObj.ts_rp = parseInt(dashboardData.totalSubscribedPin)-parseInt(dashboardData.totalMySubscribedPin);
               rootObj.ts_wp = parseInt(dashboardData.totalMySubscribedPin);
               rootObj.ts_sum = parseInt(dashboardData.totalSubscribedPin);

               if(parseInt(dashboardData.todayMySubscribedPin) > parseInt(dashboardData.yseterdayMySubscribedPin)){
                  rootObj.opc_today = dashboardData.todayMySubscribedPin;
               } else if(parseInt(dashboardData.todayMySubscribedPin) < parseInt(dashboardData.yseterdayMySubscribedPin)) {
                  rootObj.opc_today = dashboardData.todayMySubscribedPin;
               } else  {
                  rootObj.opc_today = dashboardData.todayMySubscribedPin; 
               }

               if((parseInt(dashboardData.todaySubscribedPin) - parseInt(dashboardData.todayMySubscribedPin)) > (parseInt(dashboardData.yseterdaySubscribedPin) - parseInt(dashboardData.yseterdayMySubscribedPin))){
                  rootObj.rpc_today = dashboardData.todaySubscribedPin - dashboardData.todayMySubscribedPin;
               } else if((parseInt(dashboardData.todaySubscribedPin) - parseInt(dashboardData.todayMySubscribedPin)) < (parseInt(dashboardData.yseterdaySubscribedPin) - parseInt(dashboardData.yseterdayMySubscribedPin))) {
                  rootObj.rpc_today = dashboardData.todaySubscribedPin - dashboardData.todayMySubscribedPin;
               } else  {
                  rootObj.rpc_today = dashboardData.todaySubscribedPin - dashboardData.todayMySubscribedPin;
               }

               rootObj.opc_yes = dashboardData.yseterdayMySubscribedPin;
               rootObj.yestotal = dashboardData.yseterdayMyTotalSubscribedPin;
               rootObj.rpc_yes = dashboardData.yseterdaySubscribedPin - dashboardData.yseterdayMySubscribedPin;
               rootObj.rpc_sum = dashboardData.yesterdayTotalSubscribedPin - dashboardData.yseterdayMyTotalSubscribedPin;
               rootObj.life_time_total_pins = dashboardData.lifetimePinSubscription;
               rootObj.life_time_total_pins_price = parseInt(dashboardData.lifetimePinSubscriptionSalesValue);
               rootObj.totSubscribedPin = dashboardData.totalSubscribedPin;
               rootObj.todSubscribedPin = dashboardData.todaySubscribedPin;
               rootObj.totRecharge = parseInt(dashboardData.totalRecharge);
               rootObj.todRecharge = parseInt(dashboardData.todayRecharge);
               rootObj.totalOnlineSubscribedPin = parseInt(dashboardData.totalOnlineSubscribedPin);
               rootObj.todayOnlineSubscribedPin = parseInt(dashboardData.todayOnlineSubscribedPin);
               rootObj.self_indicator = 0;
               if (rootObj.opc_today > rootObj.opc_yes) {
                  rootObj.self_indicator = 1;
               }
               if (rootObj.opc_today < rootObj.opc_yes) {
                  rootObj.self_indicator = 2;
               }

               rootObj.reseller_indicator = 0;
               if (rootObj.rpc_today > rootObj.rpc_yes) {
                  rootObj.reseller_indicator = 1;
               }
               if (rootObj.rpc_today < rootObj.rpc_yes) {
                  rootObj.reseller_indicator = 2;
               }

            })
            .catch(function (error) {
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                rootObj.loading_data = false;
                loader.hide();
                rootObj.com_errorHandel(error);
            });

            setTimeout(function(){
               loader.hide(); 
            }, 1000);
         },

         loadPaymentData(){
            var rootObject = this;
            const form = new FormData()
            form.append('noDateFilter', true)
            var config = {
             headers: { 'Content-Type': 'multipart/form-data' }
            }
            axios.post('reports/payment-report', form, config).then(function (response) {
               rootObject.populatePaymentArrData(response);
            })
            .catch(function (error) {
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                loader.hide();
                rootObject.com_errorHandel(error);
            });
         },

         populatePaymentArrData(response){
            this.paymentArr = [];
            for (var prop in response.data.data) {
               response.data.data[prop]['amount'] = parseFloat(response.data.data[prop]['amount']).toFixed(2);
               var creationdate =this.com_displayDateFormat(response.data.data[prop]['creationdate']);
               response.data.data[prop]['creationdate'] = creationdate.date;
               response.data.data[prop]['description'] = (response.data.data[prop]['description']).substr(0, 10);
               this.paymentArr.push(response.data.data[prop]);
               
            }
         },

         loadRechargeData(){
            var rootObject = this;
            const form = new FormData()
            form.append('noDateFilter', true)
            var config = {
             headers: { 'Content-Type': 'multipart/form-data' }
            }
            axios.post('reports/transaction-report', form, config).then(function (response) {
               rootObject.populateRechargeArrData(response);
            })
            .catch(function (error) {
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                loader.hide();
                rootObject.com_errorHandel(error);
            });
         },

         populateRechargeArrData(response){
            //console.log(response);
            this.rechargeArr = [];
            for (var prop in response.data.data) {
               response.data.data[prop]['amount'] = parseFloat(response.data.data[prop]['amount']).toFixed(2);
               var creationdate =this.com_displayDateFormat(response.data.data[prop]['creationdate']);
               response.data.data[prop]['creationdate'] = creationdate.date;
               this.rechargeArr.push(response.data.data[prop]); 
            }
         },

         loadTopResellerData(){
            var rootObject = this;
            this.tbl1_loading_data = true;
            axios.get('get-reseller-dropdown-data').then(function (response) {
               rootObject.reseller_list = response.data.data;
               rootObject.tbl1_loading_data = false;
            })
            .catch(function (error) {
               let alertmessage = "";
               for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
               }
               console.log(alertmessage); 
               rootObject.tbl1_loading_data = false;
               rootObject.com_errorHandel(error);
            });

            var today = this.com_currentDateTime('', 'no');
            const form = new FormData()
            form.append('report_type', 3)
            form.append('fromDate', today)
            form.append('toDate', today)
            form.append('take_rows', 5)
            var config = {
             headers: { 'Content-Type': 'multipart/form-data' }
            }
            axios.post('reports/pin-subscription', form, config).then(function (response) {
               rootObject.populateTopResellerArrData(response);
            })
            .catch(function (error) {
                let alertmessage = "";
                for (var prop in error.response.data) {
                  alertmessage += ' '+error.response.data[prop]
                }
                console.log(alertmessage);
                rootObject.com_errorHandel(error);
            });
         },

         populateTopResellerArrData(response){
            //console.log(response);
            this.topResellerArr = response.data.data;
         },

         refreshDashboard() {
            this.loadDashboardData();
            this.forceRerender();
            this.loadTopResellerData();
            this.loadRechargeData();
            this.loadPaymentData();
         },

         forceRerender() {
            // Remove my-component from the DOM
            this.renderComponent = false;
            this.$nextTick(() => {
               // Add the component back in
               this.renderComponent = true;
            });
         }
      },
      mounted: function() {
         this.adBannerUrl = this.$store.getters.getPanelData.reseller_panel_home_img;
         this.adBannerRedirectLink = this.$store.getters.getPanelData.onclick_url;
         let totalOpen = this.$store.getters.getImagePopupOpen;
         if(this.adBannerUrl != '' && ( totalOpen < 3 || totalOpen == null)){
            this.$store.dispatch('setImagePopupOpened', 1+totalOpen);
            this.imagePopup();
         }

         $('body').on("click", '.bannerhref', function(){
            $("#cboxClose").trigger('click');
         });
      }
   };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
   #cboxLoaded{
      background: red !important;
   }
   #cboxContent{
      background: red !important;
   }
</style>